import { getFunctions, httpsCallable } from "firebase/functions";
import { NotificationTransaction } from "interfaces";

export default async function sendNotificationFromClient(notification: NotificationTransaction) {

    const sendNotification = httpsCallable(getFunctions(), 'sendNotification');
    sendNotification(notification);
}
